import { render, staticRenderFns } from "./SeoSettings.vue?vue&type=template&id=fcdb75d8&scoped=true&"
import script from "./SeoSettings.vue?vue&type=script&lang=js&"
export * from "./SeoSettings.vue?vue&type=script&lang=js&"
import style0 from "./SeoSettings.vue?vue&type=style&index=0&id=fcdb75d8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb75d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcdb75d8')) {
      api.createRecord('fcdb75d8', component.options)
    } else {
      api.reload('fcdb75d8', component.options)
    }
    module.hot.accept("./SeoSettings.vue?vue&type=template&id=fcdb75d8&scoped=true&", function () {
      api.rerender('fcdb75d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/seo-settings/SeoSettings.vue"
export default component.exports